import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import { checkSubscription } from '../../utils/checkSubscription';
import AppLoader from '../AppLoader/AppLoader';
import UpgradePrompt from '../UpgradePrompt/UpgradePrompt';

const PremiumRoute = ({
	children,
	heading = 'This feature is only available to paid users',
	description = 'Upgrade to unlock premium access.',
}) => {
	const navigate = useNavigate();
	const { dbUser, isDbUserResolved } = useContext(UserContext);

	if (!isDbUserResolved) {
		return <AppLoader message='Checking your plan...' />;
	}

	if (!checkSubscription(dbUser)) {
		return (
			<UpgradePrompt
				heading={heading}
				description={description}
				onUpgrade={() => navigate('/upgrade')}
			/>
		);
	}

	return children;
};

export default PremiumRoute;
